import { render, staticRenderFns } from "./_dbSnapshotsModal.vue?vue&type=template&id=b8d72f12"
import script from "./_dbSnapshotsModal.vue?vue&type=script&lang=js"
export * from "./_dbSnapshotsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports